import React, { useEffect, useState } from "react";
import { Modal, Select, Form, Button } from "antd";
import { getOrderDetailAssignRider } from "../../../../../../services/orderManagement.service";
import { swalNotification } from "../../../../../../components/alret/notificztion";
import {formObjectIsEmpty, validationErrors } from "../../../../../../utils/Helpers";
import { getSingleStore } from "../../../../../../services/store.service";
import { getAvalibleRiderbyZone } from "../../../../../../services/riders.service";

const { Option } = Select;
const ModalAssignOrder = (props) => {
  const [postDataZone, setPostDataZone] = useState(null);
  const [MBtnLoading, setMBtnLoading] = useState(false);
  const [postDataRiderbyZone, setPostDataRiderbyZone] = useState(null);
  const [MRSLoading, setMRSLoading] = useState(true);

  useEffect(() => {
    if (props.visible) {
      postLists();
    }
  }, [props.visible]);
  const postLists = async () => {
    try {
      setMBtnLoading(true);
      const singleStore = await getSingleStore(props.OrderId);
      let zone_id = '';
      if(singleStore.data.code === 200){
        if(singleStore.data.data.zone) zone_id = singleStore.data.data.zone.id;
        setPostDataZone(singleStore.data.data.zone)
      }
      setMRSLoading(true);
      const respgetAvalibleRiderbyZone = await getAvalibleRiderbyZone(zone_id);
      // console.log(respgetAvalibleRiderbyZone.data.data);
      setPostDataRiderbyZone(respgetAvalibleRiderbyZone.data.data);
      setMRSLoading(false);
    } catch (e) {
      validationErrors(e);
    } finally {
      setMBtnLoading(false);
    }
    setMBtnLoading(false);
  };

  const handleAssignPickup = async (values) => {
    try {
      let isEmpty = formObjectIsEmpty({
        orderId: props.overviewdashboardid,
        riderId: values.riderId,
      });
      if (isEmpty) {
        throw Error("Invalid keys at Submit");
      }
      const response = await getOrderDetailAssignRider({
        orderId: props.overviewdashboardid,
        riderId: values.riderId,
      });
    } catch (e) {
      throw e;
    }
  };

  const handleOkOrder = async (values) => {
    // console.log("task", values);
    try {
      setMBtnLoading(true);
      await handleAssignPickup(values);
      swalNotification(
        "Rider Assign",
        "Rider status Assign successfully",
        "success"
      );
    } catch (e) {
      validationErrors(e);
    } finally {
      setMBtnLoading(false);
      props.setvisible(false);
      props.postListsrefresh();
    }
  };
  const handleCancel = () => {
    props.setvisible(false);
  };

  useEffect(() => {
    form.setFieldsValue(postDataRiderbyZone);
  }, [postDataRiderbyZone]);
  const [form] = Form.useForm();

  return (
    <Modal
      title="Assign Order"
      visible={props.visible}
      onCancel={handleCancel}
      footer={[
        <Button onClick={handleCancel}>Cancel</Button>,
        <Button form="modalFormAssign" loading={MBtnLoading} htmlType="submit">
          Order Assign to Rider
        </Button>,
      ]}
    >
      <Form
        form={form}
        id="modalFormAssign"
        layout="vertical"
        onFinish={handleOkOrder}
      >
        <Form.Item
          label="Zone Name"
          rules={[{ required: true, message: "Zone is Required" }]}
        >
          {postDataZone && postDataZone.zoneName}
        </Form.Item>
        <Form.Item
          label="Assign to"
          name={"riderId"}
          rules={[{ required: true, message: "Rider is Required" }]}
        >
          <Select disabled={MRSLoading} placeholder="Select Rider">
            { 
            postDataRiderbyZone ? 
              postDataRiderbyZone.map((item) => (
                <Option value={item.id}>{item.fullName} - Batch: {item.batch?.batchLevel}</Option>
              ))
              :
              <Option selected>No Rider Found</Option>
            }
          </Select>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ModalAssignOrder;
